/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';


//  签到
export const checkin = easyPost('common.welfare.sign');

//  引流弹窗
export const getDiversion = easyPost('common.diversion.get');

// 兑换
// export const getGoods = easyPost('mall.goods.searchBonusNew');

// 奖励金+钱兑换
export const getVirtualCoupons = easyPost('coupon.virtual.search');

// 奖励金+钱兑换下单
export const couponOrderCreate = easyPost('common.welfare.exchangeGoodsV2');

// 奖励金+钱兑换下单 详情页
export const detailCouponOrderCreate = easyPost('couponmall.order.create');

export const getUserCoupons = easyPost('user.wallet.coupon');

export const getCardsAndCoupons = easyPost('common.welfare.couponAndCard');

export const getAppGoods = easyPost('mall.goods.list');

export const getHelloCommand = easyPost('common.helloCommand.get');

export const getCouponAndCardGroup = easyPost('common.welfare.couponAndCardGroup');

export const getSignAndRecommend = easyPost('common.welfare.signAndRecommend');

// 纯签到弹窗信息接口（不触发自动签到）
export const getPureSignPopup = easyPost('common.welfare.new.signInfo');

export const getCommonConfig = easyPost('platform.common.config', {});

export const eventUpload = easyPost('event.platform.upload');

export const getReceiveRewardCount = easyPost('common.can.receive.reward');

export const getTaskActivity = easyPost('common.task.relation.coupon');

export const collectReward = easyPost('mars.reward.scene.collection', {
  api: config.MARKET_API,
});

export const getPopupWindow = easyPost('homepage.welfare.popupWindow');

export const getTaskAwardDetail = easyPost('common.welfare.taskAwardDetail');

// 完成任务
export const finishTask = easyPost('mars.task.jumpEvent', {
  api: config.MARKET_API,
});

// 提现sku信息
export const getWithdrawSku = easyPost('common.welfare.bonusModuleList');

// 奖励金提现
export const bonusWithdraw = easyPost('common.welfare.bonusWithdrawal', {
  risk: true,
});

// 投放banner查询
export const queryDeliverBanner = easyPost('common.welfare.banner.query');

// 获取教育弹窗
export const getEducationPopupWindow = easyPost('common.welfare.getEducationPopupWindow');

// 获取奖励金自动抵扣开关状态
export const getAutoDeductStatus = easyPost('user.bonus.config.info');

// 更改奖励金自动抵扣开关
export const updateAutoDeductStatus = easyPost('user.bonus.config.addorupdate');
// 获取福利中心样式版本
export const getWelfareStyleVersion = easyPost('common.welfare.styleVersion');

// 查询用户小组件状态
export const getUserComponent = easyPost('common.welfare.userComponent');

// 开宝箱接口
export const openTreasureBox = easyPost('common.welfare.open.treasure.box');

// 宝箱上报视频
export const reportVideoComplete = easyPost('common.welfare.report.video.treasure.box');

// 查询开宝箱浮标状态
export const getTreasureBoxFloatInfo = easyPost('common.welfare.query.treasure.box');

// ====== 福利中心顺风车心智版本 ======
// 是否为福利中心顺风车心智版本
export const checkIsWelfareHitchCarFare = easyPost('common.welfare.checkIsWelfareHitchCarFare');

// 查询单单返可领取奖励金（顺风车心智资产模块内部）
export const queryTaskCanReceiveBonus = easyPost('common.welfare.queryTaskCanReceiveBonus');

// 查询福利中心通用浮标
export const queryWelfareCommonFloat = easyPost('common.welfare.queryWelfareCommonFloat');
